import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import queueConfigurationInitialState from './state';
import { QueueState } from './Interfaces/QueueState';

const queueSlice = createSlice({
    name: 'queue',
    initialState: queueConfigurationInitialState,
    reducers: {
        SET_QUEUE_CONFIGURATION: (state, action: PayloadAction<QueueState>) => {
            const queueConfiguration = action.payload;
            return {
                ...state,
                ...queueConfiguration,
            };
        },
    },
});

export const { reducer: queueReducer, actions: queueActions } = queueSlice;
